import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled.div`
  display: inherit;
  position: relative;
`

export const PhasesCompletedRatioWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -30px;
  margin-left: -34px;
  text-align: center;
`

export const PhaseText = styled.span`
  font-size: 22px;
  font-weight: bold;
`

export const PhasesCompleted = styled.div`
  font-size: 8px;
  font-style: italic;
`

export const numerator = css`
  font-size: 34px;
  margin-right: 2px;
`

export const delimiter = css`
  margin: 0 2px;
`
